import PropTypes from 'prop-types'

function PetCard({ name, photo, petango_id, url }) {
  return (
    <div className="relative pet-card">
      <img src={photo} alt={name} loading="lazy" width="712" height="978" className="rounded-xl" />

      <div className="absolute inset-0 flex flex-col p-4 text-white">
        <div
          className="absolute inset-0 overflow-hidden bg-gradient-to-t from-black to-transparent opacity-70 rounded-xl"
          aria-hidden="true"
        ></div>

        <div className="relative mt-auto text-center">
          <div className="text-2xl font-bold md:text-3xl font-brand xl:text-4xl">{name}</div>

          {petango_id && <div className="mt-2 text-sm md:text-base richtext wysiwyg xl:text-lg">ID #{petango_id}</div>}

          <div className="mt-6 -mb-10">
            <a
              href={url}
              className="text-xs sm-down:px-2 md:text-base btn btn-fill btn-red btn-fluid lg:text-sm whitespace-nowrap xl:text-base"
            >
              <svg viewBox="0 0 512 512" className="flex-shrink-0 w-3 mr-2 md:w-4 md:mr-3" fill="currentColor">
                <path d="M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z" />
              </svg>
              <span>Adopt Me</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

PetCard.propTypes = {
  name: PropTypes.string,
  photo: PropTypes.string,
  petango_id: PropTypes.string,
  url: PropTypes.string,
}

export default PetCard
